var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9458_103517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8119 38.75L20.4726 32.3338L8.10602 38.6961L10.4863 25.1626L0.5 15.5383L14.3167 13.5703L20.5274 1.25L26.6833 13.5972L40.5 15.5922L30.4863 25.1896L32.8119 38.75Z",
    fill: "url(#paint0_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3171 13.5703L20.5004 19.9865L26.6838 13.5972L20.5278 1.25L14.3171 13.5703Z",
    fill: "url(#paint1_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 19.9865L30.4863 25.1895L40.5 15.5921L26.6833 13.5972L20.5 19.9865Z",
    fill: "url(#paint2_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5005 19.9863L20.4731 32.3336L32.8124 38.7498L30.4868 25.1894L20.5005 19.9863Z",
    fill: "url(#paint3_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5002 19.9863L10.4865 25.1625L8.1062 38.6959L20.4728 32.3336L20.5002 19.9863Z",
    fill: "url(#paint4_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4863 25.1627L0.5 15.5383L14.3167 13.5703L20.5 19.9866L10.4863 25.1627Z",
    fill: "url(#paint5_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5274 1.25L20.5 19.9865L26.6833 13.5972L20.5274 1.25Z",
    fill: "url(#paint6_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 19.9866L40.5 15.5923L30.4863 25.1897L20.5 19.9866Z",
    fill: "url(#paint7_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5005 19.9863L32.8124 38.7498L20.4731 32.3336L20.5005 19.9863Z",
    fill: "url(#paint8_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5002 19.9863L8.1062 38.6959L10.4865 25.1625L20.5002 19.9863Z",
    fill: "url(#paint9_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 15.5383L20.5 19.9866L14.3167 13.5703L0.5 15.5383Z",
    fill: "url(#paint10_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9594 32.5L20.4724 28.2324L11.9855 32.4737L13.6112 23.4378L6.75 17.01L16.2565 15.7192L20.5276 7.5L24.7435 15.7192L34.25 17.0627L27.3612 23.4642L28.9594 32.5Z",
    fill: "url(#paint11_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6545 17.0748L20.4726 19.9863L23.2907 17.0748L20.4726 11.4673L17.6545 17.0748Z",
    fill: "url(#paint12_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4731 19.9863L25.0149 22.3587L29.584 17.9913L23.2912 17.0747L20.4731 19.9863Z",
    fill: "url(#paint13_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4724 19.9863L20.4451 25.6208L26.0812 28.5323L25.0142 22.3587L20.4724 19.9863Z",
    fill: "url(#paint14_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4721 19.9863L15.903 22.3318L14.8359 28.5054L20.4447 25.6208L20.4721 19.9863Z",
    fill: "url(#paint15_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9035 22.3317L11.3618 17.9644L17.6546 17.0747L20.4726 19.9863L15.9035 22.3317Z",
    fill: "url(#paint16_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4731 11.4673V19.9863L23.2912 17.0748L20.4731 11.4673Z",
    fill: "url(#paint17_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4731 19.9867L29.584 17.9917L25.0149 22.3591L20.4731 19.9867Z",
    fill: "url(#paint18_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4724 19.9863L26.0812 28.5323L20.4451 25.6208L20.4724 19.9863Z",
    fill: "url(#paint19_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4721 19.9863L14.8359 28.5054L15.903 22.3318L20.4721 19.9863Z",
    fill: "url(#paint20_linear_9458_103517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3618 17.9644L20.4726 19.9863L17.6546 17.0747L11.3618 17.9644Z",
    fill: "url(#paint21_linear_9458_103517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9458_103517",
    x1: 0.5,
    y1: 19.999,
    x2: 40.4934,
    y2: 19.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0337079,
    stopColor: "#FACD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2904,
    stopColor: "#F9EB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3901,
    stopColor: "#FAE44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    stopColor: "#F8E048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    stopColor: "#F9D53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9D03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#E9BA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8256,
    stopColor: "#E4B429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    stopColor: "#F0C231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB8408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9458_103517",
    x1: 14.3195,
    y1: 10.6245,
    x2: 26.6811,
    y2: 10.6245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9458_103517",
    x1: 20.4968,
    y1: 19.3897,
    x2: 40.4934,
    y2: 19.3897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9458_103517",
    x1: 20.4699,
    y1: 29.3733,
    x2: 32.8187,
    y2: 29.3733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9458_103517",
    x1: 8.10081,
    y1: 29.354,
    x2: 20.497,
    y2: 29.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9458_103517",
    x1: 0.5,
    y1: 19.3648,
    x2: 20.4968,
    y2: 19.3648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF901A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3495,
    stopColor: "#EF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9458_103517",
    x1: 20.7694,
    y1: 6.03285,
    x2: 23.376,
    y2: 16.2827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9458_103517",
    x1: 36.1386,
    y1: 20.2517,
    x2: 25.1795,
    y2: 22.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9458_103517",
    x1: 27.2724,
    y1: 35.6775,
    x2: 20.2827,
    y2: 25.5889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9458_103517",
    x1: 18.9437,
    y1: 22.4199,
    x2: 11.2947,
    y2: 30.1826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9458_103517",
    x1: 25.7809,
    y1: 20.231,
    x2: 7.13497,
    y2: 14.2975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9458_103517",
    x1: 6.754,
    y1: 19.9993,
    x2: 34.2456,
    y2: 19.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9458_103517",
    x1: 17.6598,
    y1: 15.733,
    x2: 23.2848,
    y2: 15.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9458_103517",
    x1: 20.4714,
    y1: 19.7213,
    x2: 29.5709,
    y2: 19.7213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9458_103517",
    x1: 20.4587,
    y1: 24.2645,
    x2: 26.0775,
    y2: 24.2645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9458_103517",
    x1: 14.8295,
    y1: 24.2558,
    x2: 20.4703,
    y2: 24.2558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9458_103517",
    x1: 11.3713,
    y1: 19.71,
    x2: 20.4709,
    y2: 19.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9458_103517",
    x1: 20.5955,
    y1: 13.6436,
    x2: 21.7816,
    y2: 18.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9458_103517",
    x1: 27.5892,
    y1: 20.114,
    x2: 22.6022,
    y2: 21.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9458_103517",
    x1: 23.5537,
    y1: 27.1331,
    x2: 20.3732,
    y2: 22.5424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9458_103517",
    x1: 19.7635,
    y1: 21.1005,
    x2: 16.2828,
    y2: 24.6329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9458_103517",
    x1: 22.8754,
    y1: 20.1043,
    x2: 14.3906,
    y2: 17.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EFB21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9458_103517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7ea1ada645ed6dd79b6c9f1b18607111.svg";
export { ForwardRef as ReactComponent };